var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chang-phone"},[_c('span',[_vm._v(_vm._s(_vm.text))]),_c('span',{staticClass:"finger-style down-style",on:{"click":_vm.downloadApp}},[_vm._v(" "+_vm._s(_vm.$t('下载滴滴外卖App'))+" ")]),_c('i',{staticClass:"down-style icon-outline_entrance"})])
}
var staticRenderFns = []

export { render, staticRenderFns }